module.exports = __webpack_public_path__ + "static/media/wth-video.3dafdba8.mp4";